import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 个人信息
   * 目前用于借款流程
   */
  {
    path: '/information/personal',
    meta: {
      title: '个人信息',
      customNavBar: true,
    },
    component: () => import('@/views/information/personal.vue'),
  },
  /**
   * 完善信息
   * 目前用于借款流程
   */
  {
    path: '/information/complete',
    meta: {
      title: '完善信息',
      customNavBar: true,
    },
    component: () => import('@/views/information/complete.vue'),
  },
] as RouteConfig[];
